export default {
    apiKey: '564749c4-28d1-4384-b508-46a15cffe214',
    lang: 'ru_RU'
}
